import { useEffect, useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import InputMask from 'react-input-mask';
import { Context } from '../../context/UserContext';
import moment from "moment-jalali";
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import * as SignalR from '@microsoft/signalr';
import { toast } from 'react-toastify';
import ReactSelect from 'react-select';

const ListIndex = () => {

    const context = useContext(Context);
    const { readData } = useEntityCrud('ServiceConsumer/GetAllServiceConsumer');
    const [connection, setConnection] = useState(null)
    const [rows, setRows] = useState([]);
    const [isFetchedData, setIsFetchData] = useState(false);
    const [isSocketStarted, setIsSocketStarted] = useState(false);
    const [status, setStatus] = useState(1000);
    const [pan, setPan] = useState('');
    const [nationalCode, setNationalCode] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const businessIds = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))?.businessId : []
    const { addData: changeStatus } = useEntityCrud('ServiceConsumer/changeServiceConsumer');
    const { addData: updateServiceConsumers } = useEntityCrud('ServiceConsumer/UpdateServiceConsumer');
    const [deliveryModal, setDeliveryModal] = useState(false);
    const [deliverId, setDeliverId] = useState(0);
    const [deliverPreparationTime, setDeliverPreparationTime] = useState('');
    const [rowsDeliver, setRowsDeliver] = useState([]);
    const { readData: searchDeliveries } = useEntityCrud('Business/getDeliverAgents');
    const { readData: getOrderStatuses } = useEntityCrud('Report/GetOrderStatus');
    const [visible, setVisible] = useState(true)
    const [statusesList,setStatusesList] = useState([])

    let userDataBusinessId = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')).businessId : {};

    const navigate = useNavigate();
    
    useEffect(() => {
        getOrderStatuses().then(({ data }) => {
            if(data.status)
                setStatusesList([...data.result.map(item => ({label: item.title,value: item.id}))])
        })
    },[])

    const getData = (searchData) => {
        setShowLoading(true);
        const postedData = {
            offset: 0,
            limit: 10,
            ...searchData
        };
        readData(postedData).then(res => {
            if (res.data.status)
                setRows(status == 1000 ? res.data.result : res.data.result.filter(item => item.status == status));
            else
                setRows([]);
        }).finally(() => {
            setShowLoading(false);
            setIsFetchData(true)
        });
    }

    const convertToDate = date => {
        if (!date)
            return '';
        return moment(`${date.year}/${date.month}/${date.day}`, 'jYYYY/jMM/jDD').format('jYYYYjMMjDD');
    }

    const getToday = () => {
        const today = moment().format('jYYYY-jMM-jDD').split('-');
        return {
            year: +today[0],
            month: +today[1],
            day: +today[2]
        }
    }

    useEffect(() => {
        const postedData = {
            fromdate: convertToDate(fromDate) || convertToDate(getToday()),
            todate: convertToDate(toDate) || convertToDate(getToday())
        };
        getData(postedData);

        const postedData2 = {
            "businessId": userDataBusinessId ? userDataBusinessId[0] : 0,
        }
        searchDeliveries(postedData2).then(({ data }) => {
            debugger
            if (data.status) {
                setRowsDeliver(data.result.filter(item => item.isActive === true).map(item => ({
                    value: item.id,
                    label: item.person.name + " " + item.person.lastName,
                    delivername: item.person.name,
                    deliverlastname: item.person.lastName,
                    delivermobile: item.person.cellphone,
                    delivervehicle: item.vehicleNo,
                })))
            }
            else {
                toast.error(data.message)
                setRowsDeliver({})
            }
        })

    }, [fromDate, toDate])

    useEffect(() => {
        if (businessIds != null && businessIds.length && !connection) {
            const hubConnection = new SignalR.HubConnectionBuilder().withUrl('https://petromah.sabinarya.com/service/petroHub').withAutomaticReconnect().build()
            setConnection(hubConnection)
        }
    }, [businessIds, connection])

    useEffect(() => {
        if (connection && isFetchedData) {
            const sound = new Audio(`/assets/bells/single.mp3`);
            connection.on(`RecieveOrder`, data => {
                if (businessIds.includes(data.businessId)) {
                    toast.success('یک سفارش جدید در سیستم ثبت شد');
                    const oldRows = [data, ...rows];
                    setRows(oldRows);
                    sound.play();
                }
            })
            if (!isSocketStarted) {
                connection.start();
                setIsSocketStarted(true);
            }
        }
    }, [connection, isFetchedData])

    const filterData = () => {

        const postedData = {
            fromdate: convertToDate(fromDate) || convertToDate(getToday()),
            todate: convertToDate(toDate) || convertToDate(getToday())
        };
        if (mobileNo)
            postedData.mobile = mobileNo;
        if (pan)
            postedData.pan = pan;
        getData(postedData);
    }


    const handleStatusType = (consumerId, statusId) => {
        debugger
        const postedData2 = {
            "offset": 0,
            "limit": 0,
            "serviceConsumerId": consumerId,
            "status": statusId
        };

        changeStatus(postedData2).then(({ data }) => {
            debugger
            if (data.status) {
                if (statusId === 4) {
                }
                else {
                    toast.success(' وضعیت با موفقیت ثبت شد. ');
                    const postedData = {
                        fromdate: convertToDate(fromDate) || convertToDate(getToday()),
                        todate: convertToDate(toDate) || convertToDate(getToday())
                    };
                    getData(postedData);
                }
            }
            else {
                toast.error(data.message);
            }
        })
    }

    const updateServiceConsuer = (consumerId, statusId) => {
        const postedData2 = {
            "offset": 0,
            "limit": 0,
            "personId": 0,
            "registerDate": 0,
            "subServiceId": [
                0
            ],
            "serviceConsumerId": 0,
            "status": 0,
            "businessId": userDataBusinessId[0],
            "totalAmount": 0,
            "totalDiscount": 0,
            "totalPay": 0,
            "addressId": 0,
            "serviceConsumerId": consumerId,
            "delivername": deliverId.delivername,
            "deliverlastname": deliverId.deliverlastname,
            "delivermobile": deliverId.delivermobile,
            "delivervehicle": deliverId.delivervehicle,
            "deliverPreparationTime": deliverPreparationTime,
            "status": statusId,
            "additionalInfo": [
                {
                    "key": "",
                    "value": ""
                }
            ]
        };

        updateServiceConsumers(postedData2).then(({ data }) => {
            if (data.status) {
                toast.success('  اطلاعات با موفقیت ایجاد شد');
                setDeliveryModal(false)
                const postedData = {
                    fromdate: convertToDate(fromDate) || convertToDate(getToday()),
                    todate: convertToDate(toDate) || convertToDate(getToday())
                };
                getData(postedData);
                setVisible(false)
                setDeliverId({
                    value: 0,
                    label: "",
                    delivername: "",
                    deliverlastname: "",
                    delivermobile: "",
                    delivervehicle: ""
                })
                setDeliverPreparationTime("")

            } else {
                toast.error(data.message);
            }
        })
    }

    return (
        <div className="card pb-4">
            <div className="card-header">
                <div className="card-title">
                    لیست سفارشات
                </div>
            </div>
            <div className="card-body">
                <div className="row mb-4">
                    <div className="col-lg-2 col-md-3">
                        <label>وضعیت</label>
                        <select className="form-control" onChange={e => setStatus(e.target.value)} value={status}>
                            <option value={1000}>همه</option>
                            {statusesList.map(item => <option value={item.value}>{item.label}</option>)}
                        </select>
                    </div>
                    <div className="col-lg-2 col-md-3">
                        <label>شماره کارت (6 رقم از سمت راست)</label>
                        <InputMask mask="999999" className="form-control ltr-input" style={{ height: 38.2 }} value={pan} onChange={e => setPan(e.target.value)} />
                    </div>
                    <div className="col-lg-2 col-md-3">
                        <label>شماره همراه   </label>
                        <InputMask mask="0\9999999999" className="form-control ltr-input" style={{ height: 38.2 }} value={mobileNo} onChange={e => setMobileNo(e.target.value)} />
                    </div>
                    <div className="col-lg-1 col-md-3" style={{ marginTop: 29 }}>
                        <button className="btn btn-primary btn-block" onClick={filterData}>جستجو</button>
                    </div>
                </div>
                {showLoading ? <div className="loading-box">
                    <img src="/assets/images/loading.gif" alt="" />
                </div> :
                    <>
                        {rows?.length ?
                            <div className="row">
                                {rows.map((item, index) => (
                                    <div className="col-md-6" key={index}>
                                        <div className="card custom-border-1">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <p className="buyer-name">خریدار: {item.personFullName}</p>
                                                    <p className="business-title">کسب و کار: {item.businessTitle}</p>
                                                    <p className="total-amount">مبلغ کل: {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.totalAmount)} ریال</p>
                                                    <p className="discount-amount">مبلغ تخفیف: {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.totalDiscount)} ریال</p>
                                                    <p className="business-title">  شماره فاکتور : {item.serviceConsumerId}</p>
                                                    <p >
                                                        وضعیت :
                                                        <span
                                                            className={`mx-1 ${item.statusTitle === "منتظر تایید" ? "badge bg-warning px-3 py-1" :
                                                                item.statusTitle === "ثبت درخواست" ? "badge bg-secondary px-3  py-1" :
                                                                    item.statusTitle === "لغو شده" ? "badge bg-danger px-3  py-1" :
                                                                        "badge bg-success px-3"}`}
                                                        > {item.statusTitle}
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="col-md-6">
                                                    <p className="paid-amount">مبلغ پرداخت شده: {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.totalPay)} ریال</p>

                                                    <p className="payment-type">روش پرداخت: {item.payment_Type} </p>

                                                    <p className="card-number" >  شماره کارت :<span dir="ltr">{item.pan}</span></p>
                                                    <p className="created-time"  >تاریخ و ساعت :<span dir="ltr">
                                                        {(item.registerDate == null ?
                                                            '-' :
                                                            (item.registerDate.toString().slice(0, 4) + '-' + item.registerDate.toString().slice(4, 6) + '-' + item.registerDate.toString().slice(6, 8))) + ' ' + (item.registerTime || '-')}
                                                    </span></p>
                                                </div>
                                            </div>
                                            {/*  <span className="payment-status"><span
                                                className={`${item.statusTitle === "منتظر تایید" ? "badge bg-warning px-3 py-1" :
                                                    item.statusTitle === "ثبت درخواست" ? "badge bg-secondary px-3  py-1" :
                                                        item.statusTitle === "لغو شده" ? "badge bg-danger px-3  py-1" :
                                                            "badge bg-success px-3"}`}
                                            > {item.statusTitle}  </span>
                                            </span> */}
                                            <div className="operation-btn-group d-flex justify-content-between">
                                                <div className='d-flex align-items-center'>

                                                    {/*                                             {item.statuses.statuses.filter(s => s.id !== 6).filter(d => d.id > item.status).sort((a, b) => a.id - b.id).map(it => (
 */}
                                                    <>

                                                        {item.status === 1 && <button onClick={() => handleStatusType(item.serviceConsumerId, 2)}
                                                            title="منتظر تایید"
                                                            className="btn btn-icon me-1 mb-0 btn-warning">
                                                            <i className="fa fa-hourglass-start"></i>
                                                        </button>}

                                                        {item.status === 2 || item.status === 7 ? <button
                                                            onClick={() => handleStatusType(item.serviceConsumerId, item.status === 2 ? 3 : 8)}
                                                            title={item.status === 2 ? 'تایید شده و در حال آماده سازی' : 'تایید شده و در حال برگزاری'}
                                                            className="btn btn-icon me-1 mb-0 btn-success">
                                                            <i className="fa fa-check"></i>
                                                        </button> : ''}

                                                        {item.status === 3 && <button
                                                            onClick={() => handleStatusType(item.serviceConsumerId, 4)}
                                                            data-bs-toggle="collapse"
                                                            href={`#collapseFour0${item.serviceConsumerId}`}
                                                            data-bs-parent="#accordion"
                                                            aria-expanded="false"
                                                            title="ارسال شده"
                                                            className="btn btn-icon me-1 mb-0 btn-secondary">
                                                            <i className="fa fa-motorcycle"></i>
                                                        </button>}

                                                        {item.status === 4 || item.status === 8 ? <button onClick={() => handleStatusType(item.serviceConsumerId, item.status === 4 ? 5 : 9)}
                                                            title={item.status === 4  ? 'تحویل شده' : 'پایان یافته'}
                                                            className="btn btn-icon me-1 mb-0 btn-primary">
                                                            <i className="fa fa-hand-grab-o"></i>
                                                        </button> : ''}

                                                        {item.status === 2 || item.status === 7 || item.status === 8 || item.status === 9 ? <button onClick={() => handleStatusType(item.serviceConsumerId, item.status === 2 ? 6 : 10)}
                                                            title="لغو شده"
                                                            className="btn btn-icon me-1 mb-0 btn-danger">
                                                            <i className="fa fa-close"></i>
                                                        </button> : ''}

                                                        {/*                                         
                                                      <button onClick={() => handleStatusType(item.serviceConsumerId, it.id)}
                                                        title={it.title}
                                                        data-bs-toggle="collapse"
                                                        href={`#collapseFour0${item.serviceConsumerId}`}
                                                        data-bs-parent="#accordion"
                                                        aria-expanded="false"

                                                        className={`accordion-toggle collapsed  btn btn-icon me-1 mb-0 ${it.id === 1 ? "btn-info" :
                                                            it.id === 2 ? "btn-warning" :
                                                                it.id === 3 ? "btn-success" :
                                                                    it.id === 4 ? "btn-secondary" :
                                                                        it.id === 5 ? "btn-primary" : ""}`}>

                                                        <i className={`fa ${it.id === 1 ? "fa-sticky-note-o" :
                                                            it.id === 2 ? "fa-hourglass-start" :
                                                                it.id === 3 ? "fa-check" :
                                                                    it.id === 4 ? "fa-motorcycle" :
                                                                        it.id === 5 ? "fa-hand-grab-o" : ""}`}></i>
                                                    </button> */}
                                                    </>

                                                </div>

                                                <div>
                                                    {context.checkHasPermission('read') ? <Link to={'/service-consumer/view/' + item.serviceConsumerId +  "///" } className="btn btn-icon me-1 mb-0 btn-primary" title="مشاهده"><i className="fe fe-eye"></i></Link> : ''}
                                                    {context.checkHasPermission('read') ? <Link to={'/service-consumer/factor/' + item.serviceConsumerId} target="_blank" className="btn btn-icon mb-0 btn-info  me-1" title="چاپ فاکتور"><i className="fe fe-printer"></i></Link> : ''}
                                                </div>

                                            </div>
                                            {visible && <div className="panel-group1" >
                                                <div id={`collapseFour0${item.serviceConsumerId}`}
                                                    className="panel-collapse collapse position-relative"
                                                    role="tabpanel"
                                                    aria-expanded="false">

                                                    <div className="row py-4 d-flex align-items-center" style={{ textAlign: "right" }}>
                                                        <div className="col-md-5">
                                                            <div className="form-group">
                                                                <ReactSelect label=" پیک "
                                                                    options={rowsDeliver}
                                                                    value={deliverId}
                                                                    onChange={(value) => setDeliverId(value)}
                                                                    placeholder="  پیک مورد نظر را انتخاب کنید  :"
                                                                    name="deliverId"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <input type="number" min={0} maxLength={4}
                                                                    placeholder='مدت زمان تحویل'
                                                                    className="form-control" value={deliverPreparationTime}
                                                                    onChange={e => setDeliverPreparationTime(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <button className="col-md-2 btn btn-success mb-4 mt-0 btn-block btn-without-label"
                                                            onClick={() => updateServiceConsuer(item.serviceConsumerId, 4)} > ثبت پیک </button>
                                                    </div>

                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            : <div className="alert alert-info"><p>داده ای یافت نشد</p></div>
                        }
                    </>
                }
            </div>
        </div>
    )
}

export default ListIndex